export default __webpack_public_path__ + "static/media/mediterraneandrink-wide@2x.d910d29e.jpg";